"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

var _omit = _interopRequireDefault(require("lodash/omit"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Cell = function Cell(_ref) {
  var children = _ref.children,
      rest = _ref.rest;
  return (0, _core.jsx)("div", _extends({
    css: {
      display: 'table-cell',
      verticalAlign: 'middle'
    }
  }, rest), children);
};

var ErrorMessage = function ErrorMessage(_ref2) {
  var message = _ref2.message;
  return (0, _core.jsx)("div", {
    css: {
      color: 'red',
      paddingLeft: 20,
      display: 'table-cell',
      verticalAlign: 'middle'
    }
  }, (0, _core.jsx)(Cell, null, (0, _core.jsx)("span", null, message)));
};

var Child = function Child(props) {
  var type = props.type,
      ui = props.ui,
      properties = props.properties,
      name = props.name,
      disabled = props.disabled,
      rest = _objectWithoutProperties(props, ["type", "ui", "properties", "name", "disabled"]);

  return (0, _core.jsx)("input", _extends({
    css: {
      padding: '10px 15px',
      borderRadius: 4,
      border: '1px solid #aeaeae',
      background: disabled ? '#eee' : 'white'
    },
    disabled: disabled,
    type: "text",
    name: name
  }, rest));
};

var Field = function Field(props) {
  var name = props.name,
      property = props.property,
      uiProperty = props.uiProperty,
      error = props.error,
      required = props.required,
      disabled = props.disabled,
      value = props.value,
      onChange = props.onChange,
      onBlur = props.onBlur;

  var newProps = _objectSpread({
    name: name,
    error: error,
    disabled: disabled,
    value: value,
    onChange: onChange,
    onBlur: onBlur
  }, uiProperty && uiProperty.placeholder ? {
    placeholder: uiProperty.placeholder
  } : {});

  return (0, _core.jsx)("div", {
    css: {
      display: 'table',
      tableLayout: 'fixed',
      marginBottom: 20
    }
  }, (0, _core.jsx)("div", {
    css: {
      display: 'table-cell',
      verticalAlign: 'middle',
      textAlign: 'right',
      width: 200,
      paddingRight: 40
    }
  }, (0, _core.jsx)("label", {
    css: {
      width: 150
    },
    htmlFor: name
  }, property && property.title || name, required ? '*' : '')), (0, _core.jsx)(Cell, {
    css: {
      width: 500
    }
  }, (0, _core.jsx)(Child, newProps)), error ? (0, _core.jsx)(ErrorMessage, {
    message: error
  }) : null);
};

var _default = Field;
exports["default"] = _default;